"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mascali": {
    "32aa719d": [{
      "hkey": "b1c44638",
      "slug": "centro-carrabba",
      "name": "Centro-Carrabba",
      "primary": true,
      "skipSearch": false
    }],
    "carrabba": [{
      "hkey": "b1c44638",
      "slug": "centro-carrabba",
      "name": "Centro-Carrabba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7b11a172": [{
      "hkey": "6a0adb87",
      "slug": "santa-venera-portosalvo",
      "name": "Santa Venera-Portosalvo",
      "primary": true,
      "skipSearch": false
    }],
    "porto-salvo": [{
      "hkey": "6a0adb87",
      "slug": "santa-venera-portosalvo",
      "name": "Santa Venera-Portosalvo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mascali"
    }],
    "95b8beed": [{
      "hkey": "6a0adb87",
      "slug": "santa-venera-portosalvo",
      "name": "Santa Venera-Portosalvo",
      "primary": true,
      "skipSearch": false
    }],
    "santa-venera": [{
      "hkey": "6a0adb87",
      "slug": "santa-venera-portosalvo",
      "name": "Santa Venera-Portosalvo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e5d3e719": [{
      "hkey": "02f2433c",
      "slug": "tagliaborsa",
      "name": "Tagliaborsa",
      "primary": true,
      "skipSearch": false
    }],
    "tagliaborse-enclave-nel-comune-di-giarre": [{
      "hkey": "02f2433c",
      "slug": "tagliaborsa",
      "name": "Tagliaborsa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;